export const safeNotificationUrl = (value, origin = window.location.origin) => {
  try {
    const url = new URL(value || "/", origin);
    return url.origin === origin && ["http:", "https:"].includes(url.protocol)
      ? `${url.pathname}${url.search}${url.hash}` : "/";
  } catch {
    return "/";
  }
};

export const notificationUserId = (user) => user?.user?.id ?? user?.userId ?? user?.id;

export const notificationIdentity = (user) => user
  ? `${user.schoolId ?? ""}:${notificationUserId(user) ?? user.username ?? user.email ?? ""}` : "";

export const notificationBelongsTo = (data, user) => {
  const id = notificationUserId(user);
  return id != null && data?.recipientId != null && String(data.recipientId) === String(id);
};

export const readNotificationList = (body, user) => {
  const data = body?.data ?? body;
  if (body?.success === false || !Array.isArray(data?.notifications)
    || !Number.isInteger(data.unreadCount) || data.unreadCount < 0) {
    throw new Error("The notification service returned an invalid response.");
  }
  const unique = new Map();
  data.notifications.forEach((notification) => {
    if (notification.id == null || (notification.recipientId != null && !notificationBelongsTo(notification, user))) return;
    unique.set(String(notification.id), notification);
  });
  return { notifications: [...unique.values()], unreadCount: data.unreadCount };
};
